<template>
  <div v-if="!isLoading" class="columns is-variable is-6">
    <div class="column" v-for="product in products" v-bind:key="product.id">
      <router-link :to="{ name: 'manual', params: { product: product.slug } }" class="box">
        <div class="has-text-centered">
          <figure class="image is-96x96 has-margin-bottom-lg has-margin-horizontal-auto">
            <img :src="product.logo" alt="Placeholder image">
          </figure>
          <h3 class="title is-6 is-uppercase">{{ product.name }}</h3>
        </div>
      </router-link>
    </div>
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import LoadingContent from './LoadingContent'

export default {
  name: 'ProductCards',
  components: { LoadingContent },
  data () {
    return {
      isLoading: true,
      products: {}
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.isLoading = true
      API.products.index({
        take: -1,
        order_by: 'name'
      }, products => {
        this.products = products
        this.isLoading = false
      })
    }
  }
}
</script>
